// src/components/Sidebar.jsx
import React from 'react';
import { NavLink } from 'react-router-dom';
import sunoraLogo from '../assets/logo_sunora.jpg';
import geoLogo from '../assets/logo_geo.png';
import './Layout.css';

const Sidebar = () => {
    const company = localStorage.getItem("company") || "SUNORA";
    const currentLogo = company === "SUNORA" ? sunoraLogo : geoLogo;

    return (
        <aside className="sidebar">
            <div className="sidebar-header">
                <img src={currentLogo} alt="Company Logo" className="sidebar-logo" />
                <h2 className="company-name">{company}</h2>
            </div>
            <nav className="sidebar-nav">
                <NavLink to="/dashboard" end>Dashboard</NavLink>
                <p className="nav-category">Billing</p>
                <NavLink to="/billing/new">Create Invoice</NavLink>
                <NavLink to="/billing/manage">Manage Invoices</NavLink>
                <NavLink to="/manage-drafts">Manage Drafts</NavLink>
                <p className="nav-category">Masters</p>
                <NavLink to="/masters/products">Manage Products</NavLink>
                <NavLink to="/masters/customers">Manage Customers</NavLink>
                <p className="nav-category">Payments & Reports</p>
                <NavLink to="/manage-outstandings">Manage Outstandings</NavLink>
                <NavLink to="/settle-payment">Settle Payment</NavLink>
                <NavLink to="/reports/sales">Sales Report</NavLink>
                <p className="nav-category">Profile</p>
                <NavLink to="/settings/company-profile">Company Settings</NavLink>
            </nav>
            <div className="sidebar-footer"></div>
        </aside>
    );
};

export default Sidebar;